module.exports = __webpack_public_path__ + "img/icon-fb.da70ca15.svg";